import { css } from '@emotion/react';
import { useCallback } from 'react';
import { CheckboxComponent } from '~/_shared/baseComponents/checkbox';
import { notNullsy } from '~/_shared/utils/typeGuards';
import { ConstraintSlider } from '~/sidebar/sidebarApps/mapTools/boundary/loadBoundaryPane/createCustomBoundaryPane/createBoundaryGroupFromAIModal/modalSteps/constraintSlider.component';

const constraintsName = css({
  marginLeft: 10,
  paddingRight: 10,
  fontSize: 14,
});

const constraintsNameOpen = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const headingStyle = css({
  display: 'flex',
  alignItems: 'center',
});

type TerritoryOptimizationConstraintProps = {
  animationType?: 'success' | 'error';
  checked?: boolean;
  highestMin?: number | null;
  id: string;
  label: string;
  lowestMax?: number | null;
  max?: number;
  maxValue?: number;
  min?: number;
  minValue?: number;

  onChange: (id: string, change: {
    isConstraint?: boolean;
    minConstraint?: number;
    maxConstraint?: number;
  }) => void;
  onRemove?: (id: string) => void;
};

export const TerritoryOptimizationConstraint = (props: TerritoryOptimizationConstraintProps) => {
  const {
    animationType,
    checked = false,
    highestMin,
    id,
    label,
    lowestMax,
    max,
    min,
  } = props;

  const initialized = notNullsy(min) && notNullsy(max);

  const onCheckboxChange = useCallback(() => {
    props.onChange(id, { isConstraint: !checked });
  }, [checked, id, props]);

  const onSliderChange = useCallback((minConstraint: number, maxConstraint: number) => {
    props.onChange(id, { minConstraint, maxConstraint });
  }, [id, props]);

  return (
    <div key={id} >
      <div css={headingStyle}>
        <CheckboxComponent
          isChecked={checked ?? false}
          checkedSetter={onCheckboxChange}
        />
        <span css={[constraintsName, checked ? constraintsNameOpen : null]}>
          {label}
        </span>
      </div>

      {checked && initialized && (
        <ConstraintSlider
          animationType={animationType}
          highestMin={highestMin}
          lowestMax={lowestMax}
          max={max}
          min={min}
          maxValue={props.maxValue}
          minValue={props.minValue}
          onChange={onSliderChange}
        />
      )}
    </div>
  );
};
